import { CalendarPlatformIdentifier } from "0.Mine/3.Interfaces/calendar";
import { PlatformData } from "0.Mine/3.Interfaces/Integration";
import { PaymentPlatformIdentifier } from "0.Mine/3.Interfaces/PaymentPlatform";
import { ReviewPlatformIdentifier } from "0.Mine/3.Interfaces/review";
import { SocialMediaIdentifier } from "0.Mine/3.Interfaces/social";

export const socialMediaPlatforms: PlatformData[] = [
  {
    id: "facebook",
    name: SocialMediaIdentifier.FACEBOOK,
    icon: "facebook",
    description:
      "Collega la tua pagina Facebook per restare in contatto e condividere novità con i tuoi follower.",
  },
  /* {
         id: "linkedin",
         name: SocialMediaIdentifier.LINKEDIN,
         icon: "linkedin",
         description:
             "Share professional content and connect with your business network",
     },
     {
         id: "twitter",
         name: SocialMediaIdentifier.X,
         icon: "twitter",
         description:
             "Post updates and engage with your audience in real-time",
     },*/
  {
    id: "instagram",
    name: SocialMediaIdentifier.INSTAGRAM,
    icon: "instagram",
    description: "Porta colore al tuo profilo: condividi foto e video con i tuoi follower!",
  },
  /*{
        id: "tiktok",
        name: SocialMediaIdentifier.TIKTOK,
        icon: "instagram",
        description: "Share viral reels with your younger audience",
    },*/
  {
    id: "whatsapp",
    name: SocialMediaIdentifier.WHATSAPP,
    icon: "instagram",
    description: "Manda messaggi al volo e molto altro ancora!",
  },
  {
    id: "email",
    name: SocialMediaIdentifier.EMAIL,
    icon: "email",
    description: "Invia email ai tuoi clienti e follower in un lampo!",
  },
];

export const calendarPlatforms: PlatformData[] = [
  {
    id: "google-calendar",
    name: CalendarPlatformIdentifier.GOOGLE_CALENDAR,
    icon: "calendar",
    description:
      "Sincronizza il tuo calendario per gestire appuntamenti ed eventi in modo semplice e senza stress.",
  },
];

export const reviewPlatforms: PlatformData[] = [
  {
    id: "google-business",
    name: ReviewPlatformIdentifier.GOOGLE_MY_BUSINESS,
    icon: "star",
    description:
      "Gestisci e rispondi alle recensioni Google per valorizzare la tua attività, fidelizzare i clienti e attrarne di nuovi ogni giorno.",
  },
  {
    id: "tripadvisor",
    name: ReviewPlatformIdentifier.TRIPADVISOR,
    icon: "star",
    description:
      "Monitora e rispondi alle recensioni TripAdvisor per costruire fiducia, migliorare la tua immagine e attirare sempre più clienti.",
  },
  {
    id: "yelp",
    name: ReviewPlatformIdentifier.YELP,
    icon: "star",
    description:
      "Collega il tuo profilo business Yelp per gestire le recensioni, rispondere ai clienti e far crescere la tua reputazione.",
  },
];

export const paymentPlatforms: PlatformData[] = [
  {
    id: "paypal",
    name: PaymentPlatformIdentifier.PAYPAL,
    icon: "credit-card",
    description:
      "Accetta pagamenti in modo facile e sicuro per i tuoi prodotti e servizi, e fai crescere il tuo business senza confini.",
  },
  {
    id: "stripe",
    name: PaymentPlatformIdentifier.STRIPE,
    icon: "credit-card",
    description:
      "Integra Stripe per ricevere pagamenti con carta di credito in modo facile, veloce e protetto.",
  },
  {
    id: "satispay",
    name: PaymentPlatformIdentifier.SATISPAY,
    icon: "credit-card",
    description:
      "Offri ai tuoi clienti transazioni rapide e senza pensieri direttamente dal loro smartphone.",
  },
  {
    id: "credit-card",
    name: PaymentPlatformIdentifier.CREDIT_CARD,
    icon: "credit-card",
    description:
      "Ricevi pagamenti con carta di credito direttamente sulla tua piattaforma e rendi l’esperienza d’acquisto ancora più semplice per i tuoi clienti.",
  },
];
